import React, { Component } from "react";

import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";

import { LABEL_PAGE_UpgradeCloud } from "../Utils/Strings/Labels";

const styles = {
    container : {
        position: "absolute",
        background: "rgba(0,0,0, 0.1)",
        width: "100%",
        height: "100%",
        zIndex : "9999",
        display : "flex",
        flexDirection: "column",  /* make main axis vertical */
        justifyContent: "center", /* center items vertically, in this case */
        alignItems: "center",     /* center items horizontally, in this case */
    }
};

export default class BuyVersion extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {

    const USERLANGUAGE = this.props.Language;
    return (
      this.props.visible && <div style={styles.container}>
            <p>La versione attualmente in uso non supporta la gestione dal Portale BilApp.<br/>
            Se vuoi utilizzare tutte le funzionalita' del portale passa alla versione CLOUD</p>
            <RaisedButton
                label={LABEL_PAGE_UpgradeCloud[USERLANGUAGE]}
                primary={false}
                onClick={this.handleCloseAddModify}
            />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/component_BuyVersion.js